// extracted by mini-css-extract-plugin
module.exports = {"actionWidget":"ActionWidget_actionWidget__3wkfm","actionWidget_icon":"ActionWidget_actionWidget_icon__CqnkQ","actionWidget_name":"ActionWidget_actionWidget_name__PTnRI"};